import isEmpty from 'lodash.isempty';
import qs from 'qs';
import { all, put, takeLatest } from 'redux-saga/effects';
import { convertStringToInteger, getFormData } from '../../../common/utils';
import { SortingOptions } from '../../../constant/search';
import { openRoutes, protectedRoutes } from '../../../routes';
import history from '../../history';
import { searchActions } from '../search/creator';
import { activeJobsActions } from '../activeJobs/creator';

const keysToCheckForEmptyArrays = [
  'nice_to_have_skills',
  'must_have_skills',
  'location',
  'specialization',
  'institute',
  'degree',
  'organization',
  'designation',
];

function* handleLocationChange({ payload }) {
  const { isFirstRendering, location } = payload;
  if (isFirstRendering && location.pathname === protectedRoutes.searchResults) {
    if (location.search === '') {
      return history.replace(openRoutes.root);
    }
    // beStructure denotes the request payload sent to backend
    const beStructure = qs.parse(location.search, { ignoreQueryPrefix: true });
    const formData = getFormData(beStructure.query);
    if (beStructure?.sort_attrs) {
      const selectedSortOption = beStructure?.sort_attrs[0];
      formData.sort_attrs = SortingOptions.find(
        (sortingOption) => sortingOption.value.attr === selectedSortOption.attr
          && sortingOption.value.order === selectedSortOption.order,
      );
    }
    formData.id = parseInt(beStructure.jd_id, 10);
    const cleansedData = convertStringToInteger(formData);

    keysToCheckForEmptyArrays.forEach((key) => {
      if (isEmpty(cleansedData[key])) {
        delete cleansedData[key];
      }
    });

    yield put(activeJobsActions.fetchJobDetails(formData.id));
    yield put(searchActions.setSearchFormData(cleansedData));
    yield put(searchActions.searchCandidates(cleansedData));
  }
  return payload;
}

export default function* searchResultsSagas() {
  yield all([
    // to use below pattern, 'connected-react-router' is required in dependencies.
    // takeLatest('@@router/LOCATION_CHANGE', handleLocationChange),
  ]);
}
